export enum HandicapEnum {
  'VISUAL' = 'handicap visuel',
  'MENTAL' = 'handicap psychique ou cognitif',
  'MOTOR' = 'handicap moteur',
  'AUDIO' = 'handicap auditif',
}

export enum DisplayedDisabilitiesEnum {
  'VISUAL' = 'isVisualDisabilityCompliant',
  'MENTAL' = 'isMentalDisabilityCompliant',
  'MOTOR' = 'isMotorDisabilityCompliant',
  'AUDIO' = 'isAudioDisabilityCompliant',
}
